/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

var invalidProps = function invalidProps(invalidId) {
  return {
    'data-invalid': true,
    'aria-invalid': true,
    'aria-describedby': invalidId
  };
};

var warnProps = function warnProps(warnId) {
  return {
    'aria-describedby': warnId
  };
};

var textInputProps = function textInputProps(_ref) {
  var sharedTextInputProps = _ref.sharedTextInputProps,
      invalid = _ref.invalid,
      invalidId = _ref.invalidId,
      warn = _ref.warn,
      warnId = _ref.warnId;
  return _objectSpread2(_objectSpread2(_objectSpread2({}, sharedTextInputProps), invalid ? invalidProps(invalidId) : {}), warn ? warnProps(warnId) : {});
};

export { textInputProps };
